import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=ed7c6208&scoped=true"
import script from "./Factura.vue?vue&type=script&lang=js"
export * from "./Factura.vue?vue&type=script&lang=js"
import style0 from "./Factura.vue?vue&type=style&index=0&id=ed7c6208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7c6208",
  null
  
)

export default component.exports